import { library } from '@fortawesome/fontawesome-svg-core';
/*
 * Import as per recommended in Font Awesome docs
 * Order: 'far', 'fal', 'fas'
 * https://fontawesome.com/how-to-use/javascript-api/setup/importing-icons
 */
import { faArrowUpFromBracket as farArrowUpFromBracket, faBadgePercent as farBadgePercent, faBuildingColumns as farBuildingColumns, faCheck as farCheck, faCreditCard as farCreditCard, faFileLines as farFileLines, faFileMagnifyingGlass as farFileMagnifyingGlass, faFlag as farFlag, faGear as farGear, faLockKeyhole as farLockKeyhole, faMoneyBill as farMoneyBill, faPaperclip as farPaperclip, faPeriod as farPeriod, faShieldCheck as farShieldCheck, faTimes as farTimes, faTrashCan as farTrashCan } from '@fortawesome/pro-regular-svg-icons';
import { faCalculatorSimple, faCalendarExclamation, faCircleDollar, faCircleDollarToSlot, faFileInvoiceDollar, faHandsHoldingDollar, faPercent, faWallet, faAngleDown as falAngleDown, faAngleRight as falAngleRight, faAngleUp as falAngleup, faBell as falBell, faCalendar as falCalendar, faCalendarAlt as falCalendarAlt, faCircleQuestion as falCircleQuestion, faClock as falClock, faCloudArrowUp as falCloudArrowUp, faCopy as falCopy, faCreditCard as falCreditCard, faEnvelope as falEnvelope, faExclamationCircle as falExclamationCircle, faFileInvoiceDollar as falFileInvoiceDollar, faFileLines as falFileLines, faFileSearch as falFileSearch, faGlobe as falGlobe, faInfoCircle as falInfoCircle, faLock as falLock, faMessageLines as falMessageLines, faMessagesQuestion as falMessagesQuestion, faPaperclip as falPaperclip, faPhone as falPhone, faWarning as falWarning } from '@fortawesome/pro-light-svg-icons';
import { faAngleDown, faAngleUp, faBan, faCalendarAlt, faCaretDown, faCaretUp, faCheck, faCheckCircle, faChevronDown, faChevronLeft, faChevronRight, faChevronUp, faCircleCheck, faCircleNotch, faCircleQuestion, faDollarSign, faExclamationCircle, faFlag, faInfoCircle, faListAlt, faTriangleExclamation, faUniversity, faUserCircle, faWarning, faXmark, faEnvelope as fasEnvelope } from '@fortawesome/free-solid-svg-icons';
var Icons = {
    faAngleDown: faAngleDown,
    faAngleUp: faAngleUp,
    faBan: faBan,
    faCalculatorSimple: faCalculatorSimple,
    faCalendarAlt: faCalendarAlt,
    faCalendarExclamation: faCalendarExclamation,
    faCaretDown: faCaretDown,
    faCaretUp: faCaretUp,
    faCheck: faCheck,
    faCheckCircle: faCheckCircle,
    faChevronDown: faChevronDown,
    faChevronLeft: faChevronLeft,
    faChevronRight: faChevronRight,
    faChevronUp: faChevronUp,
    faCircleCheck: faCircleCheck,
    faCircleDollar: faCircleDollar,
    faCircleDollarToSlot: faCircleDollarToSlot,
    faCircleNotch: faCircleNotch,
    faCircleQuestion: faCircleQuestion,
    faDollarSign: faDollarSign,
    faExclamationCircle: faExclamationCircle,
    faFileInvoiceDollar: faFileInvoiceDollar,
    faFlag: faFlag,
    faHandsHoldingDollar: faHandsHoldingDollar,
    faInfoCircle: faInfoCircle,
    falAngleDown: falAngleDown,
    falAngleRight: falAngleRight,
    falAngleup: falAngleup,
    falBell: falBell,
    falCalendar: falCalendar,
    falCalendarAlt: falCalendarAlt,
    falCircleQuestion: falCircleQuestion,
    falClock: falClock,
    falCloudArrowUp: falCloudArrowUp,
    falCopy: falCopy,
    falCreditCard: falCreditCard,
    falEnvelope: falEnvelope,
    falExclamationCircle: falExclamationCircle,
    falFileInvoiceDollar: falFileInvoiceDollar,
    falFileLines: falFileLines,
    falFileSearch: falFileSearch,
    falGlobe: falGlobe,
    falInfoCircle: falInfoCircle,
    faListAlt: faListAlt,
    falLock: falLock,
    falMessageLines: falMessageLines,
    falMessagesQuestion: falMessagesQuestion,
    falPaperclip: falPaperclip,
    falPhone: falPhone,
    falWarning: falWarning,
    faPercent: faPercent,
    farArrowUpFromBracket: farArrowUpFromBracket,
    farBadgePercent: farBadgePercent,
    farBuildingColumns: farBuildingColumns,
    farCheck: farCheck,
    farCreditCard: farCreditCard,
    farFileLines: farFileLines,
    farFileMagnifyingGlass: farFileMagnifyingGlass,
    farFlag: farFlag,
    farGear: farGear,
    farLockKeyhole: farLockKeyhole,
    farMoneyBill: farMoneyBill,
    farPaperclip: farPaperclip,
    farPeriod: farPeriod,
    farShieldCheck: farShieldCheck,
    farTimes: farTimes,
    farTrashCan: farTrashCan,
    fasEnvelope: fasEnvelope,
    faTriangleExclamation: faTriangleExclamation,
    faUniversity: faUniversity,
    faUserCircle: faUserCircle,
    faWallet: faWallet,
    faWarning: faWarning,
    faXmark: faXmark
};
library.add.apply(library, Object.values(Icons));
//# sourceMappingURL=fontAwesomeLibrary.js.map